import { useEffect, useRef, useState } from 'react'

import { capitalizeFirstLetter } from '../../../utils/helpers'
import FilterToggle from '../FilterToggle/index'
import styles from './RepeatingValueFilter.module.scss'

const RepeatingValueFilter = ({ selectedValue, allValues, handleClick, valueName }) => {
  const [isOpen, setOpen] = useState(false)
  const [searchString, setSearchString] = useState('')

  const node = useRef()

  const handleClickIn = rateCode => {
    handleClick(rateCode)
    setOpen(false)
  }

  const handleClickOutside = e => {
    if (node.current.contains(e.target)) {
      return
    }
    setOpen(false)
  }

  useEffect(() => {
    if (isOpen) {
      document.addEventListener('mousedown', handleClickOutside)
    } else {
      document.removeEventListener('mousedown', handleClickOutside)
    }

    return () => {
      document.removeEventListener('mousedown', handleClickOutside)
    }
  }, [isOpen])

  return (
    <div className={styles.rateFilter} ref={node}>
      <FilterToggle on={selectedValue !== 'any'} onClick={() => setOpen(!isOpen)}>
        {selectedValue === 'any'
          ? `Any ${valueName}`
          : capitalizeFirstLetter(`${valueName}: ${selectedValue}`)}
      </FilterToggle>
      {isOpen && (
        <div className={styles.dialog}>
          {Object.keys(allValues).length > 12 && (
            <input
              type="search"
              className={styles.searchFilter}
              value={searchString}
              onChange={e => setSearchString(e.target.value)}
              placeholder="Type to search"
              autoFocus
            />
          )}
          <Value
            valueName={valueName}
            rate={'any'}
            isActive={selectedValue === 'any'}
            handleClick={handleClickIn}
          />
          {Object.keys(allValues)
            .sort((a, b) => allValues[b] - allValues[a])
            .filter(v => v.toUpperCase().includes(searchString.toUpperCase()))
            .map(value => (
              <Value
                isActive={selectedValue === value}
                key={value}
                rate={value}
                count={allValues[value]}
                handleClick={handleClickIn}
              />
            ))}
        </div>
      )}
    </div>
  )
}

const Value = ({ rate, count, handleClick, isActive, valueName }) => (
  <div
    className={isActive ? styles.rateActive : styles.rate}
    onClick={() => handleClick(rate)}
  >
    <div className={styles.rateName} title={rate}>
      {rate === 'any' ? `Any ${valueName}` : rate}
    </div>
    <div className={styles.rateCount}>{count}</div>
  </div>
)

export default RepeatingValueFilter
